<div class="p-grid">
	<div class="p-col">
		<p-listbox
			*ngIf="user.role < 4"
			[options]="venueSelectionsAvailable"
			[(ngModel)]="userSelectedVenues"
			[group]="userService.user.role === 5 || userService.user.role === 6"
			[checkbox]="true"
			[filter]="true"
			[multiple]="true"
			[listStyle]="{ 'max-height': '250px' }"
			[style]="{ width: '100%' }"
			(onChange)="compileUserSelectedVenues(); changesToSaveChange.emit(true)"
		>
			<ng-template *ngIf="user.role === 5 || user.role === 6" pTemplate="group" let-group>
				<div class="p-d-flex p-ai-center">
					<fa-icon [icon]="['far', 'building']"></fa-icon>
					<span>{{ group.label }}</span>
				</div>
			</ng-template>
		</p-listbox>
		<div *ngIf="user.role === 4"><i>Dealer Admin</i> role has access to all Venues attached to the Dealer Key.</div>
		<div *ngIf="user.role === 5"><i>Super Admin role</i> has access to all Dealers & Venues</div>
	</div>
</div>
